export default __webpack_public_path__ + "static/media/Izmir-Regular.ab2e3db7.woff";